<header>
  <div class="dropdown-tabs">
    <a class="nav-home" (click)="navigateHome()">
      <img class="logo" src="assets/img/hubio-logo.png">
      <p>{{ pageTitle }}</p>
    </a>
    <app-dropdown-tabs></app-dropdown-tabs>
  </div>
  <div class="user-controls">
    <div class="control-trigger" mat-button [matMenuTriggerFor]="menu">
      <p>{{ displayName }}</p>
      <mat-icon>arrow_drop_down</mat-icon>
    </div>
    <mat-menu #menu="matMenu" backdropClass="user-menu">
      <button mat-menu-item (click)="logout()">Logout</button>
    </mat-menu>
  </div>
</header>